import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { styled } from "@material-ui/core/styles";
export var DialogTitle = styled(MuiDialogTitle)({
    display: "flex",
    alignItems: "flex-start",
    position: "relative",
}, { name: "EuiDialogTitle" });
export var DialogTitleBody = styled("div")(function (_a) {
    var spacing = _a.theme.spacing;
    return ({
        flexGrow: 1,
        padding: "0.125rem 0",
        "&:not(:last-child)": {
            marginRight: spacing(4),
        },
    });
}, { name: "EuiDialogTitleBody" });
//# sourceMappingURL=DialogLayoutBase.js.map